<template>
<div class="">
    <div class="section-cont" style="height:465px;">
        <img src="../../assets/images/introduction-top-bg.png" alt="" style="width:100%;">
        <div class="pos-cont">
            <div class="top-cont">
                <span class="left-text">园数聚</span>
                <span class="right-text">园区数据聚合分析平台</span>
            </div>
            <div class="bottom-cont">
                集园区、园企数据查询、数据分析、大屏展示等功能于一体
            </div>
        </div>
    </div>
    <div class="section-cont section-bg1">
        <div class="small-cont">
            <div class="introduct-title">产业地图</div>
            <div class="flex-cont">
                <div class="flex-item introduct-desc">
                    <div class="top-bg top-bg1">
                        <span></span>
                    </div>
                    <div class="center-text">大湾区宏观数据</div>
                    <div class="bottom-desc" style="width:76%;">湾区9城宏观数据一目了然，配以城市间企业迁徙数据，挖掘各地区的产业关系特点。</div>
                </div>
                <div class="flex-item introduct-desc">
                    <div class="top-bg top-bg2">
                        <span></span>
                    </div>
                    <div class="center-text">数据地图</div>
                    <div class="bottom-desc" style="width:100%;">圈出目标区域即可生成园区及园企数据统计报表，同时可查看区域内园区和园企名单，可实现对区域产业分析。</div>
                </div>
                <div class="flex-item introduct-desc">
                    <div class="top-bg top-bg3">
                        <span></span>
                    </div>
                    <div class="center-text">产业热力图</div>
                    <div class="bottom-desc" style="width:90%;">以热力图形式直观呈现30多种热门行业企业及多种优质企业分布，帮助用户实现区域招商策略制定。</div>
                </div>
            </div>
            <div class="experience">
                点击体验
            </div>
        </div>
    </div>
    <div class="section-cont section-bg2">
        <div class="small-cont">
            <div class="introuct-store">
                <div class="details">
                    <div class="title">商业办公、产品研发类载体</div>
                    <div class="detail-item">动态数据更新</div>
                    <div class="detail-item">地址关联企业识别与下载</div>
                    <div class="detail-item">可用于园区竞品分析</div>
                    <div class="detail-item">可用于园区行业发展分析</div>
                    <div class="detail-experience">点击体验</div>
                </div>
            </div>
        </div>
    </div>
    <div class="section-cont section-bg1">
        <div class="small-cont">
            <div class="introduct-title">园区大屏</div>
            <div class="flex-cont" style="margin-bottom:50px">
                <div class="flex-item introduct-desc introduct-desc1">
                    <div class="top-bg top-bg4">
                        <span></span>
                    </div>
                    <div class="center-text">一键生成</div>
                    <div class="bottom-desc" style="width:84%;">用户仅需选定目标园区，系统智能生成园企基础工商、优质企业、知识产权、企业招聘、企业来源、周边优质企业分布等XX个维度数据统计。</div>
                    <div class="bottom-btn">点击生成</div>
            </div>
                <div class="flex-item introduct-desc introduct-desc1">
                    <div class="top-bg top-bg5">
                        <span></span>
                    </div>
                    <div class="center-text">专属大屏</div>
                    <div class="bottom-desc" style="width:88%;">注册并认领大屏，即可导入企业名单可生成您的专属数据大屏，企业数据持续更新。</div>
                    <div class="bottom-btn">点击认领</div>
                </div>
                <div class="flex-item introduct-desc introduct-desc1">
                    <div class="top-bg top-bg6">
                        <span></span>
                    </div>
                    <div class="center-text">多模板切换</div>
                    <div class="bottom-desc" style="width:89%;">多套酷炫模板切换，展示效果更精彩，让园区实力和形象展示有了更专业的选择。</div>
                    <div class="bottom-btn">点击体验</div>
                </div>
                <div class="flex-item introduct-desc introduct-desc1">
                    <div class="top-bg top-bg7">
                        <span></span>
                    </div>
                    <div class="center-text">深度定制方案</div>
                    <div class="bottom-desc" style="width:88%;">可根据用户需求提供数据聚合、数据分析与可视化等一体化解决方案。</div>
                    <div class="bottom-btn">点击咨询</div>
                </div>
            </div>
        </div>
    </div>
    <div class="section-cont section-bg2">
        <div class="small-cont">
            <div class="introduct-title">行业信息</div>
            <div class="introduct-sub-title">聚合全国政策、土地、展会、活动等信息，让您更便捷掌握行业动态</div>
            <div class="flex-cont">
                <div class="flex-item introduct-panel introduct-panel1">
                    <span class="iconimg iconimg1"></span>
                    <span class="text">查政策</span>
                </div>
                <div class="flex-item introduct-panel introduct-panel2">
                    <span class="iconimg iconimg2"></span>
                    <span class="text">查土地</span>
                </div>
                <div class="flex-item introduct-panel introduct-panel3">
                    <span class="iconimg iconimg3"></span>
                    <span class="text">查展会</span>
                </div>
                <div class="flex-item introduct-panel introduct-panel4">
                    <span class="iconimg iconimg4"></span>
                    <span class="text">查活动</span>
                </div>
            </div>
        </div>
    </div>
    <commonfooter></commonfooter>
</div>
</template>

<script>
import commonfooter from "../../common/commonfooter";
import qs from "qs";
export default {
    name: "",
    data() {
        return {

        };
    },
    components: {
        commonfooter
    },
    computed: {},
    created() {},
    mounted() {},
    methods: {}
};
</script>

<style lang="scss">
</style>



// WEBPACK FOOTER //
// src/components/index/introduction.vue